module.exports = __webpack_public_path__ + "images/category_lp/common/icon-step1_e469c7ecb53aecd9b93280644318dd17.png";